// @ts-nocheck
import { ApiHandlerDiscreteParameter, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { getReturnSlip } from "@store/Framework/Services/ReturnSlipService";
import { GetReturnSlipApiParameter, ReturnSlipModel } from "@store/Framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<{ returnSlipId: string }, GetReturnSlipApiParameter, ReturnSlipModel>;

export const DispatchBeginLoadReturnSlip: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/ReturnSlip/BeginLoadReturnSlip",
        returnSlipId: props.parameter.returnSlipId,
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        returnSlipId: props.parameter.returnSlipId,
    };
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getReturnSlip(props.apiParameter);
    } catch (error) {
        if ("status" in error && (error.status === 400 || error.status === 404 || error.status === 401)) {
            const status = error.status === 401 ? 401 : 404;
            props.dispatch({
                type: "Store/Pages/ReturnSlip/FailedToLoadReturnSlip",
                returnSlipId: props.parameter.returnSlipId,
                status,
            });
            return false;
        }
        throw error;
    }
};

export const DispatchCompleteLoadReturnSlip: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/ReturnSlip/CompleteLoadReturnSlip",
        model: props.apiResult,
    });
};

export const chain = [
    DispatchBeginLoadReturnSlip,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadReturnSlip,
];

const displayReturnSlip = createHandlerChainRunner(chain, "DisplayReturnSlip");
export default displayReturnSlip;
